import {QrCode, UserCheck, IdCard, CheckCircle} from 'lucide-react';
import {useTranslation} from 'react-i18next';

function ScanQrAtPropertyInfoBox() {
  const {t} = useTranslation('identity-verification');

  return (
    <div className="text-left flex flex-col gap-4 w-full p-4 rounded-[16px] bg-[var(--background-secondary)] mb-6 text-sm font-normal leading-6">
      <div className="flex gap-2 items-center w-full text-base font-semibold leading-6 ">
        <QrCode size={20} className="flex-shrink-0" />
        {t('qr_scan_required_at_property')}
      </div>

      <p className="text-left whitespace-break-spaces">
        {t('when_you_arrive_at_property_you_must')}
        <strong className="mx-0.5">
          {t('scan_the_qr_code_located_at_the_entrance')}
        </strong>
        {t('this_allows_you_to')}
      </p>

      <div className="flex flex-col gap-2 w-full">
        <div className="flex gap-4 items-start w-full">
          <div className="flex items-center justify-center w-8 h-8 flex-shrink-0 rounded-full bg-[rgba(56,91,248,0.1)] text-brand ">
            <UserCheck size={20} />
          </div>
          <p className="text-left m-0 text-sm font-normal leading-6  flex-1 flex items-center min-h-[32px]">
            {t('verify_your_presence_at_the_property')}
          </p>
        </div>

        <div className="flex gap-4 items-start w-full">
          <div className="flex items-center justify-center w-8 h-8 flex-shrink-0 rounded-full bg-[rgba(56,91,248,0.1)] text-brand ">
            <IdCard size={20} />
          </div>
          <p className="text-left m-0 text-sm font-normal leading-6  flex-1 flex items-center min-h-[32px]">
            {t('access_identity_verification')}
          </p>
        </div>

        <div className="flex gap-4 items-start w-full">
          <div className="flex items-center justify-center w-8 h-8 flex-shrink-0 rounded-full bg-[rgba(56,91,248,0.1)] text-brand ">
            <CheckCircle size={20} />
          </div>
          <p className="text-left m-0 text-sm font-normal leading-6  flex-1 flex items-center min-h-[32px]">
            {t('complete_your_check_in_process')}
          </p>
        </div>
      </div>
    </div>
  );
}

export {ScanQrAtPropertyInfoBox};
